import React from 'react';
import { ButtonCircle } from '../../Button';
import PropTypes from 'prop-types';

import styles from './rightbartabs.module.scss';

export class RightbarTab extends React.Component {
  render() {
    const { children } = this.props;

    return (
      <div className={styles.tab}>
        {children}
      </div>
    );
  }
}

export class RightbarTabs extends React.Component {
  handleBtnClick = (index) => () => {
    const { activeTabIndex } = this.state;

    const newActiveTabIndex = activeTabIndex === index ? null : index;

    this.setState({
      activeTabIndex: newActiveTabIndex,
    });
  };

  getTabs = () => {
    const { children, setActiveTab } = this.props;

    const tabs = [];

    React.Children.forEach(children, child => {
      tabs.push({
        child,
        button: {
          label: child.props.label,
          iconName: child.props.iconName,
          iconClassName: child.props.iconClassName || '',
          iconChildren: child.props.iconChildren,
          onClick: () => setActiveTab(child.props.label),
        },
      });
    });

    return tabs;
  };

  render() {
    const { activeLabel } = this.props;

    const tabs = this.getTabs();

    return (
      <div className={styles.tabs}>
        {activeLabel !== null &&
          tabs.find(tab => tab.button.label === activeLabel).child
        }
        <ul className={styles.list}>
          {tabs.map((tab, k) => (
            <li className={styles.item} key={k}>
              <ButtonCircle
                iconName={tab.button.iconName}
                className={`${tab.button.iconClassName} ${tab.button.label === activeLabel ? '_selected' : ''}`}
                onClick={tab.button.onClick}
              >
                {tab.button.iconChildren}
              </ButtonCircle>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

RightbarTabs.propTypes = {
  activeLabel: PropTypes.string,
  setActiveTab: PropTypes.func,
};
